import React from 'react';
import block from 'bem-cn-lite';
import ImageArea from './ImageArea/';
import {Comments, Avatars} from '../Components/Comments';
import Repeater from '../Components/Repeater';
import TrialTooltip from '../Components/TrialTooltip';
import ProofingPanel from '../Components/ProofingPanel';
import { TransitionGroup } from 'react-transition-group';
import { FadeTransition, SlideUpTransition } from '../Components/Transitions';
import createEvent from '../createCustomEvent';
import i18n from '../i18n';
import { I18n } from 'react-i18next';

block.setup({
    mod: '--',
});

const initialState = {
    isCommenting: false,
    isDisabled: false,
    markerPosition: null,
    isVisibleRepeater: false,
    isVisibleCursorTooltip: true,
    isVisibleTrialTooltip: false,
    comments: [
        {
            text: i18n.t('imageProofing:defaultComment'),
            author: i18n.t('global:marketer'),
            avatar: Avatars.marketer,
            markerColor: '#4488ff',
            time: i18n.t('global:1hour')
        }
    ]
};

class ImageProofing extends React.Component {
    state = {...initialState}

    addComment = (commentText) => {
        const comment = {
            text: commentText,
            time: i18n.t('global:rightNow'),
            avatar: Avatars.designer,
            markerColor: '#f8008c',
            author: i18n.t('global:designer')
        };

        const finalComment = {
            text: i18n.t('imageProofing:answer'),
            time: i18n.t('global:rightNow'),
            avatar: Avatars.marketer,
            markerColor: '#4488ff',
            author: i18n.t('global:marketer')
        };

        const {comments, isDisabled} = this.state;

        if (isDisabled) {
            return false;
        }

        this.setState({
            comments: [...comments, comment, finalComment],
            isCommenting: false,
            isDisabled: true
        });

        window.dispatchEvent(createEvent('IMAGE_PROOFING_ACTION', {detail: 'Added Comment: ' + commentText}));

        setTimeout(this.showRepeater, 5000);
    }

    showRepeater = () => {
        this.setState({
            isVisibleRepeater: true
        });
    }

    setInitialState = () => {
        this.setState({...initialState});
        window.dispatchEvent(createEvent('IMAGE_PROOFING_ACTION', {detail: 'Reloaded Screenshoot'}));
    }


    addMarker = (markerPosition) => {
        this.setState({
            markerPosition: markerPosition,
            isCommenting: true,
            isVisibleCursorTooltip: false
        });

        if (this.textArea) {
            this.textArea.focus();
        }

        window.dispatchEvent(createEvent('IMAGE_PROOFING_ACTION', {detail: 'Added Marker'}));
    }

    showTrialTooltip = () => {
        this.setState({
            isVisibleTrialTooltip: true
        });

        window.dispatchEvent(createEvent('IMAGE_PROOFING_ACTION', {detail: 'Clicked on Panel'}));

        clearTimeout(this.timerid);

        this.timerid = setTimeout(this.hideTrialTooltip, 2000);
    }

    hideTrialTooltip = () => {
        this.setState({
            isVisibleTrialTooltip: false
        });
    }

    render() {
        const b = block('ImageProofing');

        const { image } = this.props
        const {
            comments,
            isCommenting,
            isDisabled,
            isVisibleRepeater,
            markerPosition,
            isVisibleTrialTooltip
        } = this.state;

        return (
            <I18n ns={[ 'global', 'imageProofing' ]}>
            {
                () => (
                    <div className={b()} style={ { backgroundImage: image ? `url(${image})` : null } }>

                        <TransitionGroup>
                            {isVisibleRepeater && 
                                <FadeTransition>
                                    <Repeater onClick={this.setInitialState}/>
                                </FadeTransition>
                            }
                        </TransitionGroup>

                        <TransitionGroup>
                            {isVisibleTrialTooltip && 
                                <SlideUpTransition>
                                    <TrialTooltip width={'465px'}/>
                                </SlideUpTransition>
                            }
                        </TransitionGroup>

                        <ImageArea
                            onClick={this.addMarker}
                            markerPosition={markerPosition}
                            isCommenting={isCommenting}
                            isDisabled={isDisabled}/>
                        <Comments
                            comments={comments}
                            textAreaRef={(ref) => this.textArea = ref}
                            onSubmitCommentInput={this.addComment}
                            userAvatar={Avatars.designer}
                            isVisibleCommentInput={isCommenting}/>
                        <div
                            onClick={this.showTrialTooltip}
                            className={b('panel')}>

                            <ProofingPanel>
                                <img src="https://cdn.wrike.com/image/__cdnu/illustration_abstract_image-proofing-panel.svg" alt="" />
                            </ProofingPanel>

                        </div>
                    </div>
                )
            }
            </I18n>
        );
    }
}

export default ImageProofing;
